import { render, staticRenderFns } from "./AgeRating18.vue?vue&type=template&id=b8f3d144"
import script from "./AgeRating18.vue?vue&type=script&lang=js"
export * from "./AgeRating18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports